export default __webpack_public_path__ + "static/media/cert-hr-consumer.0df9093a.jpg";